<template>
  <section class="trading-details" :class="{ 'trading-details--dark': $vuetify.theme.dark }">
    <!-- <h1>Trading Details</h1> -->
    <v-card elevation="0" class="all-trade-tab trading-details__card rounded-0">
      <v-tabs v-model="model" class="trading-details__tabs" background-color="transparent" hide-slider>
        <v-tab :href="`#tab-1`">Live Trades</v-tab>
        <v-tab :href="`#tab-2`">Closed Trades</v-tab>
        <v-tab :href="`#tab-3`">Charts</v-tab>
      </v-tabs>
      <v-tabs-items v-model="model" class="trading-details__items">
        <v-tab-item :value="`tab-1`"><v-card flat><live-tab /></v-card></v-tab-item>
        <v-tab-item :value="`tab-2`"><v-card flat><close-tab /></v-card></v-tab-item>
        <v-tab-item :value="`tab-3`"><v-card flat><chart-tab /></v-card></v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import ChartTab from './ChartTab.vue';
import CloseTab from './CloseTab.vue';
import LiveTab from './LiveTab.vue';

export default {
  name: "LiveTradeTabs",
  components: {
    LiveTab,
    CloseTab,
    ChartTab,
  },

  data() {
    return {
      model: "tab-1",
    };
  },
  mounted() {
    if (this.$route.query.tab) {
      this.model = `tab-${this.$route.query.tab}`;
    }
  },
  watch: {
    model: function (newModel) {
      const tab = newModel.split('-')[1];
      if (tab && String(this.$route.query.tab) !== String(tab)) {
        this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, tab } });
      }
    },
    '$route.query.tab': function (newTab) {
      if (newTab) {
        this.model = `tab-${newTab}`;
      }
    },
  },
};
</script>

<style scoped>
.trading-details {
  --panel: #fff;
  --border: #e0e3e7;
  --text: #15181d;
  --muted: #626973;
  min-height: calc(100vh - 112px);
  color: var(--text);
}
.trading-details--dark {
  --panel: #07111b;
  --border: #293026;
  --text: #f5f7ff;
  --muted: #aeb6c0;
}
.trading-details h1 { margin: 0 0 14px; color: var(--text); font-size: 22px; line-height: 1.25; }
.trading-details__card, .trading-details__items { background: transparent !important; }
.trading-details__items ::v-deep .v-window-item > .v-card { background: transparent !important; }
.trading-details__tabs { margin-bottom: 14px; }
.trading-details__tabs ::v-deep .v-tabs-bar { height: 36px !important; background: transparent !important; }
.trading-details__tabs ::v-deep .v-tab {
  min-width: 112px;
  height: 36px;
  margin: 0 8px 0 0 !important;
  padding: 0 20px;
  border: 1px solid var(--border) !important;
  border-radius: 5px !important;
  background: var(--panel) !important;
  color: var(--muted) !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}
.trading-details__tabs ::v-deep .v-tab--active {
  border-color: #d99a00 !important;
  background: linear-gradient(180deg, #ffc826, #e4a500) !important;
  color: #17130a !important;
  box-shadow: 0 6px 16px rgba(191, 137, 0, .2);
}
@media (max-width: 600px) {
  .trading-details h1 { font-size: 20px; }
  .trading-details__tabs ::v-deep .v-tab { min-width: 98px; padding: 0 12px; }
}
</style>
